var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_421_1191)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_421_1191)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_421_1191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.582 13.0273H31.335V13.6621C31.335 14.1801 31.1292 14.6769 30.7629 15.0432C30.3966 15.4095 29.8998 15.6152 29.3818 15.6152C28.8638 15.6152 28.3671 15.4095 28.0008 15.0432C27.6345 14.6769 27.4287 14.1801 27.4287 13.6621V13.0273H17.5713V13.6621C17.5713 14.1801 17.3655 14.6769 16.9992 15.0432C16.6329 15.4095 16.1362 15.6152 15.6182 15.6152C15.1002 15.6152 14.6034 15.4095 14.2371 15.0432C13.8708 14.6769 13.665 14.1801 13.665 13.6621V13.0273H13.418C12.5115 13.0273 11.6421 13.3875 11.0011 14.0284C10.3601 14.6694 10 15.5388 10 16.4453V31.582C10 32.4885 10.3601 33.3579 11.0011 33.9989C11.6421 34.6399 12.5115 35 13.418 35H31.582C32.4885 35 33.3579 34.6399 33.9989 33.9989C34.6399 33.3579 35 32.4885 35 31.582V16.4453C35 15.5388 34.6399 14.6694 33.9989 14.0284C33.3579 13.3875 32.4885 13.0273 31.582 13.0273ZM33.0469 30.3613C33.0469 30.714 32.9774 31.0632 32.8425 31.389C32.7075 31.7149 32.5097 32.0109 32.2603 32.2603C32.0109 32.5097 31.7149 32.7075 31.389 32.8425C31.0632 32.9774 30.714 33.0469 30.3613 33.0469H14.6387C14.286 33.0469 13.9368 32.9774 13.611 32.8425C13.2851 32.7075 12.9891 32.5097 12.7397 32.2603C12.4903 32.0109 12.2925 31.7149 12.1576 31.389C12.0226 31.0632 11.9531 30.714 11.9531 30.3613V21.084C11.9531 20.3717 12.2361 19.6887 12.7397 19.185C13.2433 18.6814 13.9264 18.3984 14.6387 18.3984H30.3613C30.714 18.3984 31.0632 18.4679 31.389 18.6029C31.7149 18.7378 32.0109 18.9356 32.2603 19.185C32.5097 19.4344 32.7075 19.7304 32.8425 20.0563C32.9774 20.3821 33.0469 20.7313 33.0469 21.084V30.3613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1611 11.2207V13.6621C28.1611 14.3363 28.7077 14.8828 29.3818 14.8828C30.056 14.8828 30.6025 14.3363 30.6025 13.6621V11.2207C30.6025 10.5465 30.056 10 29.3818 10C28.7077 10 28.1611 10.5465 28.1611 11.2207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3975 11.2207V13.6621C14.3975 14.3363 14.944 14.8828 15.6182 14.8828C16.2923 14.8828 16.8389 14.3363 16.8389 13.6621V11.2207C16.8389 10.5465 16.2923 10 15.6182 10C14.944 10 14.3975 10.5465 14.3975 11.2207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.251 20.4736H15.0537C14.5144 20.4736 14.0771 20.9109 14.0771 21.4502V23.6475C14.0771 24.1868 14.5144 24.624 15.0537 24.624H17.251C17.7903 24.624 18.2275 24.1868 18.2275 23.6475V21.4502C18.2275 20.9109 17.7903 20.4736 17.251 20.4736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5986 20.4736H21.4014C20.862 20.4736 20.4248 20.9109 20.4248 21.4502V23.6475C20.4248 24.1868 20.862 24.624 21.4014 24.624H23.5986C24.138 24.624 24.5752 24.1868 24.5752 23.6475V21.4502C24.5752 20.9109 24.138 20.4736 23.5986 20.4736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9463 20.4736H27.749C27.2097 20.4736 26.7725 20.9109 26.7725 21.4502V23.6475C26.7725 24.1868 27.2097 24.624 27.749 24.624H29.9463C30.4856 24.624 30.9229 24.1868 30.9229 23.6475V21.4502C30.9229 20.9109 30.4856 20.4736 29.9463 20.4736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.251 26.8213H15.0537C14.5144 26.8213 14.0771 27.2585 14.0771 27.7979V29.9951C14.0771 30.5345 14.5144 30.9717 15.0537 30.9717H17.251C17.7903 30.9717 18.2275 30.5345 18.2275 29.9951V27.7979C18.2275 27.2585 17.7903 26.8213 17.251 26.8213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5986 26.8213H21.4014C20.862 26.8213 20.4248 27.2585 20.4248 27.7979V29.9951C20.4248 30.5345 20.862 30.9717 21.4014 30.9717H23.5986C24.138 30.9717 24.5752 30.5345 24.5752 29.9951V27.7979C24.5752 27.2585 24.138 26.8213 23.5986 26.8213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9463 26.8213H27.749C27.2097 26.8213 26.7725 27.2585 26.7725 27.7979V29.9951C26.7725 30.5345 27.2097 30.9717 27.749 30.9717H29.9463C30.4856 30.9717 30.9229 30.5345 30.9229 29.9951V27.7979C30.9229 27.2585 30.4856 26.8213 29.9463 26.8213Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_421_1191",
    x: 0,
    y: 0,
    width: 45,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.908 0 0 0 0 1 0 0 0 0 0.7125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_421_1191"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_421_1191",
    x: -3,
    y: 1,
    width: 51,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176011 0 0 0 0 0.516667 0 0 0 0 0.120556 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_421_1191"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_421_1191",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_421_1191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.f4d4449bc9bfada662d013ab7d58822a.svg";
export { ForwardRef as ReactComponent };